// Country
export const All = 'all'
export const Thailand = 'thailand'
export const Malaysia = 'malaysia'
export const Singapore = 'singapore'
export const Philippines = 'philippines'
export const Indonesia = 'indonesia'
export const Australia = 'australia'
export const Newzealand = 'newzealand'
export const Japan = 'japan'
export const Korea = 'korea'
export const Hongkong = 'hongkong'
export const Vietnam = 'vietnam'
export const MENA = 'mena'
export const Myanmar = 'myanmar'
export const Cambodia = 'cambodia'
export const Laos = 'laos'
export const Taiwan = 'taiwan'
export const Morocco = 'morocco'
// Language
export const Arabic = 'arabic'
export const Bahasa = 'bahasa'
export const Japanese = 'japanese'
export const Korean = 'korean'
export const Thai = 'thai'
export const Vietnamese = 'vietnamese'
export const Khmer = 'khmer'
export const Burmese = 'burmese'
export const Lao = 'lao'
export const Chinese = 'chinese'
export const Mandarin = 'mandarin'
export const Cantonese = 'cantonese'
export const Malay = 'malay'
export const French = 'french'
// Stage
export const Production = 'production'
export const Development = 'development'
export const Localhost = 'localhost'
// Footer
export const English = 'english'
export const Native = 'native'
export const Roman = 'roman'
// Payment
export const OCBC = 'ocbc'
export const OCBCExpress = 'ocbcExpress'
export const UnionPay = 'unionpay'
export const Hydra = 'hydra'
export const TwoCTwoP = '2c2p'
export const ECPay = 'ecpay'
// Geolocation
export const Longitude = 'longitude'
export const Latitude = 'latitude'
// Variables
export const Unknown = 'unknown'
export const Default = 'default'
// Pages
export const AddressBook = 'addressbook'
// Shipping
export const Delivery = 'delivery'
export const PickUp = 'pickUp'
export const Aramex = 'aramex'
export const DeliverySBY = 'deliverySBY'
export const MotorDelivery = 'motorDelivery'
export const MotorDeliverySBY = 'motorDeliverySBY'
export const PickUpTaguig = 'pickUpTaguig'
export const SamedayDelivery = 'samedayDelivery'
// Payment
export const CreditCard = 'CreditCard'
export const BankWire = 'BankWire'
export const GCash = 'GCash'
// Balance features
export const CashCoupon = 'CashCoupon'
export const ARBalance = 'ARBalance'
// Status
export const Status = {
    A: 'A',
    B: 'B',
    C: 'C',
    E: 'E',
    L: 'L',
    H: 'H'
}